import { render, staticRenderFns } from "./CreateUsers.vue?vue&type=template&id=5c635ae2&scoped=true&"
import script from "./CreateUsers.vue?vue&type=script&lang=js&"
export * from "./CreateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c635ae2",
  null
  
)

export default component.exports